import { createContext } from 'react';

export const OpFormContext = createContext({
  isDataLoading: false,
  isReadOnly: false,
});
